// extracted by mini-css-extract-plugin
export var brand = "_7j-8";
export var compact = "_7j-5";
export var extraSmall = "_7j-6";
export var icon = "_7j-0";
export var large = "_7j-3";
export var light = "_7j-1";
export var medium = "_7j-4";
export var outline = "_7j-a";
export var primaryDark = "_7j-9";
export var primaryLight = "_7j-7";
export var primaryModern = "_7j-b";
export var success = "_7j-2";